import * as React from "react";
import { graphql, Link } from "gatsby";
import CategoryPage from "./category";
import { SEO } from "../components/HeadMeta";

export const Head = ({ data, pageContext }) => {
    return <SEO pathname={pageContext.pagePath}/>;
};

const TagsPage = (props) => {
    return <CategoryPage {...props} />;
};
export const query = graphql`
    query TagsQuery ($category: String!) {
        results: allMarkdownRemark(
            sort: { frontmatter: { created: DESC } }
            limit: 100
            skip: 0
            filter: { frontmatter: { tags: { in: [$category] } } }
        ) {
            posts: edges {
                post: node {
                    excerpt
                    id
                    fields {
                        path
                    }

                    frontmatter {
                        tags
                        title
                        created
                        categories
                        __typename
                        heroImage: coverImage {
                            childImageSharp {
                                gatsbyImageData(width: 1200)
                            }
                        }
                        thumbImage: coverImage {
                            childImageSharp {
                                gatsbyImageData(width: 400)
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default TagsPage;
